export default function AjaxDataSend(config) {
  $.ajax({
    url: config.url,
    type: "POST",
    data: config.data,
    cache: false,
    dataType: 'json',
    complete: function(responseStr) {

    },
    success: function (response) {
      if (response.success === true || response.success === 1) {
        if (typeof config.onSuccess === "function") {
          config.onSuccess(response);
        }
      } else {
        if (typeof config.onError === "function") {
          config.onError(response);
        }
      }
      if (typeof config.onComplete === "function") {
        config.onComplete(response, true);
      }
    },
    error: function (response) {
      if (typeof config.onError === "function") {
        config.onError(response);
      }
      if (typeof config.onComplete === "function") {
        config.onComplete(response, false);
      }
    },
    beforeSend:function () {
      if (typeof config.beforeSend === "function") {
        config.beforeSend();
      }
    }
  });
}
